/**
* Toast do tipo sucesso (cor verde).
*/
const SUCCESS = 0;

/**
* Toast do tipo aviso (cor amarela).
*/
const WARNING = 1;

/**
* Toast do tipo erro (cor vermelha).
*/
const ERROR = 2;

/**
* Toast do tipo informação (cor neutra - azul).
*/
const INFO = 3;

export default
{
	SUCCESS,
	WARNING,
	ERROR,
	INFO,
};